<section class="login-container">
  <div><img src="../../../assets/images/login-img.png" /></div>
  <div class="login-form-container">
    <img class="blue-logo-img" src="../../../assets/images/Intel-blue-logo.png" />
    <button mat-flat-button color="primary" (click)="ssoLoginPopup()">
      LOGIN USING SSO <i class="fa fa-arrow-right"></i>
    </button>
  </div>
</section>
